import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import * as moment from 'moment-timezone';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor() {
        moment.tz.setDefault('America/Argentina/Buenos_Aires'); // Set to Argentina timezone
    }
}
